<template>
  <b-modal
    dialog-class="modal-dialog2"
    contentClass="md-confirm-content"
    :hideHeader= "true"
    bodyClass= "confirm-body"
    footerClass= "confirm-footer"
    :okTitle= "$t('common.ok')"
    :cancelTitle= "$t('common.cancel1')"
    okVariant= "primary md_btn_primary"
    cancelVariant= "secondary md_btn_light"
    centered
    :visible="visible"
    @hidden="onCancel"
    @ok="onOk"
  >
    <div class="wrapper">
      <div v-if="item.f_name != ''&& item.f_name != undefined"
           class="page_title">
        {{item.f_name}}
      </div>
      <div v-if="address != ''&& address != undefined"
           style="margin-top: 5px"
           class="address_text">
        <b-img :src="require('../../../assets/image/ic_address_detail@2x.png')"
               style="margin-left: 7px; height: 20px; vertical-align: text-bottom;"
        />
        {{address}}
      </div>

      <b-input v-model="searchPhone"
               :formatter="Utils.formatPhoneNumber"
               :placeholder="$t('group.transfer_phone_placeholder')"
               class="search_box search_input"
               style="margin-top:20px;"
               @change="onSearch"
      />
      <b-button style="margin-top: 15px; background-color: #457fff"
                class="button"
                @click="onSearch"
      >
        {{$t('group.view')}}
      </b-button>
      <div v-if="destMember != null"
           style="margin-top: 25px"
           class="dest_member_wrapper btnLabel"
      >
        {{this.destMember.f_name}}
      </div>
      <div style="margin-top: 20px"
           class="contentLabel">
        {{$t('group.transfer_warning_desc')}}
      </div>
      <div v-if="destMember != null"
           style="margin-top: 25px;"
           class="titleLabel">
        {{u.format($t('group.transferred_to_sb'), destMember.f_name)}}
      </div>
    </div>
  </b-modal>
</template>

<script>
import Utils from "../../../config/utils";
const $u = require('util');
export default {
  name: "TransferPopup",
  inject: ["eventBus"],
  props:{
    visible:{
      type:Boolean,
      default:false,
    },
    item:{
      type:Object,
      default: null,
    }
  },
  data() {
    return {
      Utils:Utils,
      searchPhone:'',
      isVisit: false,
      destMember: null,
      u:$u
    }
  },
  methods:{
    onSearch(){
      if (!this.searchPhone)
      {
        Utils.toast(this, this.$t('group.enter_phone_number'));
        return;
      }
      Utils.requestGet(this.$c.API.User.findUserByPhone, {
        phone: this.searchPhone.replaceAll('-', '')
      }).then(result => {
        if (result.code !== this.$c.API_RES_CODE.SUCCESS) {
          Utils.toast(this, result.msg);
        } else {
            this.isVisit = true;
            this.destMember = result.data;
        }
      });
    },
    onOk(e){
      e.preventDefault();
      if (this.isVisit && this.destMember){
        Utils.requestPost(this.$c.API.Site.transferSite, {
          dest_member_idx: this.destMember.f_idx,
          site_idx: this.item.f_idx,
        }).then(result => {
          if (result.code == this.$c.API_RES_CODE.SUCCESS) {
            this.$emit('remove',this.item.f_idx);
            // Utils.toast(this, this.$t('site_report.transfer_site_done'));
            this.eventBus.$emit('sale_complete')
          } else {
            Utils.toast(this, result.msg);
          }
        });
        this.onCancel();
      }else{
        Utils.toast(this,this.$t('group.confirm_destination'));
      }
    },
    onCancel(e){
      this.$emit('update:visible', false);
    }
  },
  computed:{
    address(){
      return Utils.getAddress(this.item, true);
    }
  },
  watch:{
    visible(){
      if (!this.visible){
        this.destMember = null;
        this.searchPhone = '';
        this.isVisit= false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
 @import "../../../assets/css/_vars.scss";

 .wrapper{
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
 }
 .titleLabel{font-size: $fs_22; color: $black; text-align: center; font-family: $korean_gd_15_r};
 .contentLabel{
   font-size: $fs_18;
   color: #cf0000;
   text-align: center;
   font-family: $korean_gd_14_r;
   text-decoration: underline;
 };
 .search_box{
   height: 50px;
   border: solid 1px #c4c3c3;
   border-radius: 2px;
   padding:12px;
 }

 .search_input{
   color: $black;
   font-size: $fs_18;
   font-family: $korean_gd_14_r;
   text-align: center;
   width: 70%;
   height: 40px;
 }
 .page_title {
   color: $black;
   font-size: $fs_24;
   font-family: $korean_gd_15_r;
 }

 .address_text {
   color: #0660e2;
   font-size: $fs_18;
   font-family: $korean_gd_14_r;
   margin-left: 6px;
 }

 .button{
   width: 63px;
   height: 36px;
   border-radius: 3px;
   background-color: $c_cacbcd;
   font-size: 16px;
   font-family: 'KoreanGD14R';
 };

 .btnLabel{color: $white; font-size: $fs_16; font-family: $korean_gd_15_r; };

 .dest_member_wrapper{
   display: flex;
   align-items: center;
   justify-content: center;
   width: fit-content;
   background-color: $c_cacbcd;
   border:solid 1px $c_cacbcd;
   padding:0 20px;
   height: 43px;
   color: black;
   font-size: $fs_22;
   font-family: $korean_gd_15_r;
 }

 ::placeholder{
   color: $c_a6a6a6;
 }
</style>



// WEBPACK FOOTER //
// src/components/controls/popup/TransferPopup.vue